import * as React from 'react';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Stack } from '@mui/material';
import {formatLocalDateAsUtc, USAGE_TYPE} from "./common";
import CardOverflow from "@mui/joy/CardOverflow";
import CardActions from "@mui/joy/CardActions";
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { apiPost } from '../../service/api-service';
import dayjs from "dayjs";

interface PricingNewProps {
  setGlobalLoading: (loading: boolean) => void;
  setReload: () => void;
  setVisible: (visible: boolean) => void;
  toast: any;
}

export default function BillingPricingNew(props: PricingNewProps) {
  const [usageType, setUsageType] = React.useState<number | null>(null);
  const [effectiveDate, setEffectiveDate] = React.useState<Date | null>(null);
  const [costClientPerUnit, setCostClientPerUnit] = React.useState<number | null>(null);

  async function addNewPrice() {
    if (!usageType || !effectiveDate || !costClientPerUnit) {
      props.toast.current.show({ severity: 'warn', summary: 'Please fill in all required fields', life: 3000 });
      return;
    }

    props.setGlobalLoading(true);
    try {
      await apiPost('core', 'billing/pricing', {
        usage_type: usageType,
        effective_date: formatLocalDateAsUtc(effectiveDate, false),
        cost_client_per_unit: costClientPerUnit.toString()
      });
      props.toast.current.show({ severity: 'success', summary: 'New pricing added successfully', life: 3000 });
      props.setVisible(false);
      props.setReload();
    } catch (error) {
      props.toast.current.show({ severity: 'error', summary: 'Failed to add new pricing', life: 3000 });
    }
    props.setGlobalLoading(false);
  }

  return (
    <React.Fragment>
      <Stack spacing={2} sx={{flexGrow: 1}} style={{width: '100%'}}>
        <Stack spacing={1}>
          <label>Usage Type <span style={{color: 'red'}}>*</span></label>
          <Dropdown
            value={usageType}
            options={USAGE_TYPE}
            onChange={(e) => setUsageType(e.value)}
            placeholder="Select Usage Type"
            className="PrimeSmallInput"
            style={{ fontSize: 'small', padding: 0 }}
          />
        </Stack>

        <Stack spacing={1}>
          <label>Effective Date (UTC) <span style={{color: 'red'}}>*</span></label>
          <Calendar
            value={effectiveDate}
            onChange={(e) => setEffectiveDate(e.value as Date)}
            showIcon
            minDate={new Date()}
          />
        </Stack>

        <Stack spacing={1}>
          <label>Client Cost <span style={{color: 'red'}}>*</span></label>
          <InputNumber
            value={costClientPerUnit}
            onValueChange={(e) => setCostClientPerUnit(e.value || null)}
            mode="decimal"
            minFractionDigits={2}
            maxFractionDigits={2}
            placeholder="Enter cost"
            className="PrimeSmallInput"
            prefix="R"
            style={{ fontSize: 'small', padding: 0 }}
          />
        </Stack>

        <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
          <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
            <Button
              type="button"
              icon="pi pi-save"
              label="Save"
              className="p-button-outlined"
              size="small"
              style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }}
              onClick={() => addNewPrice()}
            />
          </CardActions>
        </CardOverflow>
      </Stack>
    </React.Fragment>
  );
}
